export default {
  emptyPlaceholder: 'Drag and drop files to here to upload.',
  addFile: 'Add files',
  removeAllFiles: 'Remove all files',
};
